import React, { useState } from "react";
import "./Footer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import {
  faPhone,
  faHome,
  faPlantWilt,
  faPhotoVideo,
  faNewspaper,
  faScroll,
  faArrowRight,
  faSpinner,
  faCheck,
  faClose,
  faExclamation,
} from "@fortawesome/free-solid-svg-icons";

function Footer() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [requestState, setRequestState] = useState('default')
  const [isSuccess, setIsSuccess] = useState(false);
  const buttonIcons = {
    success: <FontAwesomeIcon style={{ scale: "1.5" }} icon={faCheck} />,
    error: <FontAwesomeIcon style={{ scale: "1.5" }} icon={faClose} />,
    loading: <FontAwesomeIcon  className='rotate-animation' style={{ scale: "1.5" }} icon={faSpinner} />,
    default:   <FontAwesomeIcon style={{ scale: "1.5" }} icon={faArrowRight} />
  }



  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const handleSubscription = async (e) => {
    e.preventDefault();
   
    if(email.length < 0 || emailRegex.test(email)){
     
      try{
    
        setIsLoading(true)
        setErrors('')
        setRequestState('loading')
        const response = await fetch('https://www.viverosantaisabel.com/api/newsletter',
          {
            headers: {
              "Content-Type": "application/json", // Ensures the server knows it's JSON
            },
            method: 'POST',
            body: JSON.stringify({email: email})
          }
        )

      const data = await response.json();
    
        
        if(data.status === 201){
          setTimeout(() => {
            setRequestState('success')
            setIsSuccess(true)
            setIsLoading(false)
           }, 1500);
          setTimeout(() => {
            setRequestState('default');
            setIsSuccess(false);
           }, 3500);
        }else{
        
          setErrors(data.error.userMessage)
          setRequestState('error')
          setIsLoading(false)
          setTimeout(() => {
            setRequestState('default')
           }, 1000);
        }
      }catch(error){
        setIsLoading(false)
        setRequestState('error')
        setErrors('Error en el servidor, intente mas tarde.') 
      
        setTimeout(() => {
              setRequestState('default');
             }, 1500);
      }
       
    }else{
      
     setErrors('Introduzca un mail valido')
     setRequestState('error')
     setIsLoading(false)
     setTimeout(() => {
      setRequestState('default')
     }, 1000);
    }

  }
  return (
    <div className="footer-container">
      <div className="footer-text-container">
        <div className="footer-map-container">
          <div className="footer-map-title">Mapa del sitio</div>

          <div className="footer-map-items-container">
            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faHome}
                ></FontAwesomeIcon>
              </span>
              <a href="/" className="footer-map-item">
                Home
              </a>
            </div>

            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faPlantWilt}
                ></FontAwesomeIcon>
              </span>
              <a href="/productos" className="footer-map-item">
                Productos
              </a>
            </div>

            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faPhotoVideo}
                ></FontAwesomeIcon>
              </span>
              <a href="/galeria" className="footer-map-item">
                Galería
              </a>
            </div>

            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faNewspaper}
                ></FontAwesomeIcon>
              </span>
              <a href="/noticias" className="footer-map-item">
                Noticias
              </a>
            </div>

            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faScroll}
                ></FontAwesomeIcon>
              </span>
              <a href="/historia" className="footer-map-item">
                Historia
              </a>
            </div>

            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faPhone}
                ></FontAwesomeIcon>
              </span>
              <a href="/contacto" className="footer-map-item">
                Contacto
              </a>
            </div>
          </div>
        </div>

        <div className="footer-contact-container">
          <div className="footer-contact-title">Contacto</div>

          <div className="footer-contact-items-container">
            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faPhone}
                ></FontAwesomeIcon>
              </span>
              <div className="footer-contact-number">
                San Pedro: +54 3329 582241
              </div>
            </div>

            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faPhone}
                ></FontAwesomeIcon>
              </span>
              <div className="footer-contact-number">
                San Pedro: +54 3329 410429
              </div>
            </div>

            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faPhone}
                ></FontAwesomeIcon>
              </span>
              <div className="footer-contact-number">
                Santo Tomé +54 342 4742472
              </div>
            </div>

            <div className="footer-contact-single">
              <span className="fa-layers">
                <FontAwesomeIcon
                  className="footer-icon"
                  icon={faPhone}
                ></FontAwesomeIcon>
              </span>
              <div className="footer-contact-number">
                Venado Tuerto +54 3462 316418
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-media-container">
        <div className="footer-media-item">
          <div className="footer-media-title">Encontranos en</div>

          <div className="footer-media-icons-container">
            <a
              className="footer-media-a"
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/viverosantaisabelsp"
            >
              <FontAwesomeIcon
                className="footer-media-icon"
                icon={faFacebook}
              ></FontAwesomeIcon>
              Facebook
            </a>
            <a
              className="footer-media-a"
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/viverosantaisabelsp/"
            >
              <FontAwesomeIcon
                className="footer-media-icon"
                icon={faInstagram}
              ></FontAwesomeIcon>
              Instagram
            </a>
            <a
              className="footer-media-a"
              target="_blank"
              rel="noreferrer"
              href="https://www.google.com/search?gs_ssp=eJzj4tZP1zcsSUkuLswxN2C0UjWosDRNSjQyNExNtTRJNE4yMrQyqDA0SklLTk1KNTNJMUszN0nxEi7LLEstylcoTswrSVTILE5MSs0BACOMFvE&q=vivero+santa+isabel&rlz=1C1ONGR_esAR1010AR1010&oq=vivero+snaa&aqs=chrome.2.69i57j46i13i175i199i512l2j0i13i512l2j46i13i175i199i512j0i13i512l3j69i64.5631j0j4&sourceid=chrome&ie=UTF-8#lrd=0x95ba211ee94a3b21:0x12dfcebe64d6f74d,1,,,,"
            >
              <FontAwesomeIcon
                className="footer-media-icon"
                icon={faGoogle}
              ></FontAwesomeIcon>
              Google
            </a>
          </div>

          <div className="footer-media-news-title">Sobre nosotros</div>

          <div className="footer-media-news-text">
            En Vivero Santa Isabel somos uno de los productores más grandes de
            La Argentina, contamos con todo tipo de especies, productos y
            herramientas para tus proyectos o jardín.
          </div>
        </div>
        <div className="footer-media-item">
        <div className="newsletter">
          <div className="newsletter__content">
            <h2>Newsletter</h2>
            <p>Suscribite y no te pierdas ninguna novedad.</p>
            <div className="action">
              <input  className={isSuccess ? "success" : ''}  type="email" onChange={(e) => setEmail(e.target.value)}  placeholder="Email" />
             
              <button className={isSuccess ? "success" : ''} onClick={(e) => handleSubscription(e)} disabled={isLoading}>
                {buttonIcons[requestState]}
              </button>
            </div>
            {errors.length > 1 && (
                <span><FontAwesomeIcon style={{marginRight: '5px'}} icon={faExclamation}/>{errors}</span>
              )}
          </div>
        </div>

        </div>
      </div>
      <a
            href="https://destinyti.com/"
            target="_blank"
            className="copyright"
            rel="noreferrer"
          >
            Desarrollado por <strong>DESTINY</strong>
            <img width={50} height={50} src="logoDestiny.png" alt="" />
          </a>
    </div>
  );
}

export default Footer;
